<template>
    <div class="price-info">
        <div class="price-info__inner">
            <div class="price__info__item loading" v-if="!invoice?.sub_total"></div>
            <div class="price__info__item" v-if="invoice?.sub_total !== null">
                <span class="price__info__item__key">قیمت کالاها:</span>
                <div class="price__info__item__value">
                    {{numberFormat(invoice.sub_total)}}
                    <span class="price__info__item__monetary-unit">تومان</span>
                </div>
            </div>
            <div class="price__info__item price__info__item--off" v-if="invoice?.discount">
                <span class="price__info__item__key">تخفیف:</span>
                <div class="price__info__item__value">
                    ({{invoice.discount_percentage}}%) {{numberFormat(invoice.discount)}}
                    <span class="price__info__item__monetary-unit">تومان</span>
                </div>
            </div>
            <div class="price__info__item" v-if="invoice?.shipping !== null">
                <span class="price__info__item__key">هزینه ارسال:</span>
                <div class="price__info__item__value" v-if="invoice.shipping">
                    {{numberFormat(invoice.shipping)}}
                    <span class="price__info__item__monetary-unit">تومان</span>
                </div>
                <div class="price__info__item__value" v-else>
                    <small style="font-size: 12px;">رایگان</small>
                </div>
            </div>
            <div class="price__info__item price__info__item--final" v-if="invoice?.total">
                <span class="price__info__item__key">مبلغ قابل پرداخت:</span>
                <div class="price__info__item__value">
                    {{numberFormat(invoice.total)}}
                    <span class="price__info__item__monetary-unit">تومان</span>
                </div>
            </div>
            <p class="price__info__text" v-if="invoice.shipping === null">
                هزینه‌ی ارسال در ادامه بر اساس آدرس، زمان و نحوه‌ی ارسال
                انتخابی شما‌ محاسبه و به این مبلغ اضافه خواهد شد.
            </p>
            <div class="price-info__btn-wrapper">
                <button @click="next" :disabled="!proceedable" class="btn custom-btn custom-btn--primary price-info__btn">
                    {{nextButtonLabel}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Totaling",
    props: ["proceedable", "invoice", "step"],
    emits: ["next"],
    methods: {
        next() {
            this.$emit('next');
        }
    },
    computed: {
        nextButtonLabel() {
            return this.step === 'shipping' ? 'انتخاب شیوه پرداخت' : 'پرداخت و تکمیل خرید'
        }
    }
}
</script>

<style scoped>

</style>
